// extracted by mini-css-extract-plugin
module.exports = {"productCounter":"_r-Uho","shine-lines":"ZRFzUX"};